import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisuallyHidden from 'components/consumer/VisuallyHidden';

// Small circular icon button used for the gallery's floating controls
// (favorite/zoom stack, expanded-gallery close and zoom).
const PDPGalleryRevampCircleButton = t0 => {
  const $ = _c(9);
  const {
    ariaLabel,
    children,
    disabled: t1,
    onClick
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames("items-center flex justify-center h-9 w-9 rounded-full bg-white border border-solid border-gray-light6", "hover:bg-gray-light9 hover:cursor-pointer focus-visible:outline-brand disabled:hover:bg-white disabled:hover:cursor-default", "[&_svg_path]:fill-gray-dark disabled:[&_svg_path]:fill-gray-light4");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== ariaLabel) {
    t3 = <VisuallyHidden>{ariaLabel}</VisuallyHidden>;
    $[1] = ariaLabel;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== ariaLabel || $[4] !== children || $[5] !== disabled || $[6] !== onClick || $[7] !== t3) {
    t4 = <button type="button" aria-label={ariaLabel} onClick={onClick} disabled={disabled} className={t2}>{children}{t3}</button>;
    $[3] = ariaLabel;
    $[4] = children;
    $[5] = disabled;
    $[6] = onClick;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
PDPGalleryRevampCircleButton.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};
export default PDPGalleryRevampCircleButton;